export function decodeJWT(token: string) {
  return JSON.parse(atob(token.split('.')[1]));
}